<template>
  <div class="admin-entity-canvas">
    <div
      v-if="$slots['floating-panel']"
      class="admin-entity-canvas__floating pb-2"
    >
      <slot name="floating-panel" />
    </div>
    <div class="admin-entity-canvas__body">
      <slot name="body" />
    </div>
  </div>
</template>

<script>
import {defineComponent} from 'vue';

/**
 * Lightweight layout for admin entity list/detail screens.
 * Avoids HitAppBaseCanvas from the main app (which mounts HitMenuSidebar / routes like addressList).
 */
export default defineComponent({
  name: 'AdminEntityCanvas',
});
</script>

<style lang="scss" scoped>
.admin-entity-canvas {
  display: flex;
  flex-direction: column;
  min-height: 0;
  height: 100%;
}

.admin-entity-canvas__body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  grid-row-gap: 1rem;
}
</style>
